import {Component, DoCheck, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {ChangeFiltersService, HtmlHelper, Product, ProductService, RecipeService} from '../shared/shared.module';
import {Dropdown} from 'primeng/components/dropdown/dropdown';
// tslint:disable-next-line:import-blacklist
import {Subscription} from 'rxjs';
import {timer} from 'rxjs/observable/timer';

@Component({
  selector: 'app-ingredient-filter',
  templateUrl: './ingredient-filter.component.html',
  styleUrls: ['./ingredient-filter.component.scss']
})
export class IngredientFilterComponent implements OnInit, DoCheck {

  constructor(
      private productService: ProductService,
      private recipeService: RecipeService,
      private changeFiltersService: ChangeFiltersService
  ) { }

  allowResetMenu;
  @ViewChild('dd') productDropdown: Dropdown;
  defaultProduct = new Product();
  selectedProduct: Product;
  products: Product[];
  maxProducts = 5;
  selectedProducts: Product[] = new Array<Product>();
  searchString = '';
  timer: Subscription;
  startSearch: boolean;
  isMobile = false;
  windowWidth: number = window.innerWidth;
  @Output() ingredientFilterAmountCheck = new EventEmitter<number>();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  ngOnInit(): void {
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
    this.recipeService.sortHashObs.subscribe( x => {
      if (x === 2) {
        const arrOfPromise = [];
        this.recipeService.productsIdHash.forEach( id => {
          const promise = this.productService.getIngredientById(id).then( product => {
            if (product[0]) {
              this.selectedProducts.push(product[0]);
              this.ingredientFilterAmountCheck.emit(this.selectedProducts.length);
            }
          });
          arrOfPromise.push(promise);
        });
        Promise.all(arrOfPromise).then( res => {
          const selectedProductsId = [];
          this.selectedProducts.forEach(prod => selectedProductsId.push(prod.Id_Product));
          this.recipeService.setFilter('QFiltr', selectedProductsId.length ? selectedProductsId.join(',') : undefined);
          this.recipeService.pushProgressInHash('ingredients');
        });
      }
    });
    this.recipeService.getFilterState().subscribe(x => {
      if (x !== null) {
        this.clearFilter();
      }
    });

    this.changeFiltersService.getAllowResetRecipes().subscribe(x => {
      this.allowResetMenu = x;
    });

    this.changeFiltersService.getStateReadyMenu().subscribe(x => {
      if (this.allowResetMenu && !this.isMobile && this.selectedProducts.length) {
        this.clearFilter();
      }
    });
  }

  private getFilteredProducts(term: string) {
    if (this.timer) {
      this.timer.unsubscribe();
    }
    this.searchString = term === '' ? undefined : term;
    this.timer = timer(500).subscribe(() => {
      this.startSearch = true;
      if (this.searchString && this.searchString.length > 2) {
        this.productService.setFilterAll('Name', this.searchString);
        this.productService.get().then(products => {
          if (products) {
            products.map( (product: Product) => {
              return product.SortedBy = this.searchString;
            });
          }
          this.products = products.length ? products : null;
          this.startSearch = false;
        });
        return;
      }
      this.products = null;
      this.startSearch = false;
    });
    if (!this.searchString && !this.products) {
      this.products = null;
    }
  }

  onDropdownChange(event, dropdown: Dropdown): void {
    // Ограничение на макс. количество и уникальность
    if (this.selectedProducts.length < this.maxProducts
        && !this.selectedProducts.some(x => x.Id_Product === this.selectedProduct.Id_Product)) {
      this.selectedProducts.push(this.selectedProduct);
      this.ingredientFilterAmountCheck.emit(this.selectedProducts.length);
    }
    this.onMultiselectChange();
  }

  onRemoveButtonClick(event, index): void {
    this.selectedProducts.splice(index, 1);
    this.ingredientFilterAmountCheck.emit(this.selectedProducts.length);
    this.onMultiselectChange();
  }

  clearFilter() {
    this.selectedProducts.splice(0, this.selectedProducts.length);
    this.ingredientFilterAmountCheck.emit(this.selectedProducts.length);
    this.onMultiselectChange();
  }

  onMultiselectChange() {
    this.recipeService.setSearchStatus(true);
    const selectedProductsId = [];
    this.selectedProduct = new Product();
    this.selectedProduct.Id_Product = 0;
    this.selectedProduct.FullName = undefined;
    this.selectedProducts.forEach(x => selectedProductsId.push(x.Id_Product));
    this.recipeService.setFilter('QFiltr', selectedProductsId.length ? selectedProductsId.join(',') : undefined);
    if (!this.isMobile) {
      this.recipeService.get();
      this.recipeService.getShort();
    }
  }

  ngDoCheck(): void {
    if (!this.startSearch && this.productDropdown && this.productDropdown['el'].nativeElement) {
      const filterInputField =
          this.productDropdown['el'].nativeElement.getElementsByClassName('ui-dropdown-filter ui-inputtext')[0] || null;
      const addLabel = this.productDropdown['el'].nativeElement.querySelector('label');
      if (addLabel.innerHTML !== 'Добавить') {
        addLabel.innerHTML = 'Добавить';
      }
      if (filterInputField) {
        const searchString = filterInputField['value'];
        if (this.searchString !== searchString) {
          this.getFilteredProducts(searchString);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/ingredient-filter/ingredient-filter.component.ts